export const profileColors = [
    "#5dade2",
    "#e74c3c",
    "#2ecc71",
    "#8e44ad",
    "#f39c12 ",
    "#17a589",
    "#e61e5e",
    "#734c4c",
];